import { ReactElement } from 'react';

import { ExternalModule } from 'src/router/components';

import { BrowserTitle, AnalyticsTrackPageView } from ':components';
import { APP_LK_SICK_HOST } from ':constants';

// TODO: remove this page after, sickList fix
// temporary solution
export function SickListPage(): ReactElement {
  return (
    <>
      <BrowserTitle title='Больничные листы' />
      <AnalyticsTrackPageView />
      <ExternalModule
        host_url={APP_LK_SICK_HOST}
        component_id='lk-sickLeave/sickLeaveManagerService'
      />
    </>
  );
}
